module.exports = __webpack_public_path__ + "img/heart_scotland.e7a4f165.jpg";